import { useDispatch } from "react-redux";
import CardHeaderBG from "../../../components/components-library/card-header-bg";
import TotalsCard from "../../../components/components-library/totals-card";
import { FC } from "react";
import { TCompoTotals } from "../../../types/eiskEngine";
const TotalsWeightcards: FC<{
  totals: TCompoTotals | null;
}> = ({ totals }) => {
  const dispatch = useDispatch();

  return (
    <>
      <div className="grid grid-cols-3 gap-4 w-full">
        <CardHeaderBG
          titile={"Total Parameters"}
          titileClassName="bg-oceangreen"
          className=""
          icon=""
          subText="Active Configurations"
        >
          <div className="flex card_space_18">
            <TotalsCard
              headerName={""}
              totalVal={totals ? totals.total_parameters : ""}
              isValueBold={true}
            ></TotalsCard>
          </div>
        </CardHeaderBG>
        <CardHeaderBG
          titile={"Total Rules"}
          titileClassName="bg-oceangreen"
          className=""
          icon=""
          subText="Evaluation conditions"
        >
          <div className="flex card_space_18">
            <TotalsCard
              headerName={""}
              totalVal={totals ? totals?.total_rules : ""}
              isValueBold={true}
            ></TotalsCard>
          </div>
        </CardHeaderBG>
        <CardHeaderBG
          titile={"Weight Base"}
          titileClassName="bg-oceangreen"
          className=""
          icon=""
          subText="Perfectly balanced"
        >
          <div className="flex card_space_18">
            <TotalsCard
              headerName={""}
              totalVal={totals ? totals?.weight_base : ""}
              isValueBold={true}
            ></TotalsCard>
          </div>
        </CardHeaderBG>
      </div>
    </>
  );
};
export default TotalsWeightcards;
